import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { canEditPetition, Loading, petitionSlugCanonicalRedirect } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petition-edit-v2',
		path: '/p/:slug/edit-v2',
		beforeServerRender: petitionSlugCanonicalRedirect,
		component: loadable(async () => import(/* webpackChunkName: "pages/petition_edit_v2" */ './index'), {
			exportName: 'PetitionEditV2',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', canEditPetition('slug')],
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: false,
		},
	},
];
